// ============================================================================
// JARVISTRAVEL - EMAILED CODE LENGTH
// Clerk emails 6-digit codes, for sign-up verification and for password reset.
// Every screen that takes one reads this constant, so the screens can't drift
// apart again. ForgotPasswordScreen asked for 8 while VerifyEmailScreen asked
// for 6, and nobody could finish a password reset (JAR-1405).
// ============================================================================

export const CODE_LENGTH = 6;

/** Seconds before an emailed code can be requested again, on every screen that sends one. */
export const RESEND_COOLDOWN_SECONDS = 120;
export const emptyCode = () => Array<string>(CODE_LENGTH).fill('');
